import React, { useState } from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  LabelList,
  Cell
} from "recharts";
import { FaChartBar, FaThLarge } from "react-icons/fa";
import "./BattleStats.css";

const BattleStatsToggle = ({ stats }) => {
  const [showGraph, setShowGraph] = useState(false);

  const data = [
    { name: "Matches", value: stats.total_matches || 0 },
    { name: "Kills", value: stats.total_kills || 0 },
    { name: "Coins", value: stats.coins_won || 0 },
    { name: "Win %", value: stats.winning_rate || 0 },
  ];

  const barColors = ['#6366f1', '#8b5cf6', '#a855f7', '#d946ef'];

  return (
    <div className="battle-stats-container dark-theme">
      <div className="toggle-section">
        <button 
          className={`view-toggle ${showGraph ? 'active' : ''}`}
          onClick={() => setShowGraph(!showGraph)}
        >
          {showGraph ? (
            <>
              <FaThLarge className="toggle-icon" />
              <span>Card View</span>
            </>
          ) : (
            <>
              <FaChartBar className="toggle-icon" />
              <span>Graph View</span>
            </>
          )}
        </button>
      </div>

      {!showGraph ? (
        <div className="stats-grid">
          {data.map((stat, index) => (
            <div className="stat-card" key={stat.name}>
              <div className="stat-header">
                <h3>{stat.name}</h3>
              </div>
              <div className="stat-value" style={{ color: barColors[index] }}>
                {stat.name === 'Win %' ? `${stat.value}%` : stat.value.toLocaleString()}
              </div>
              <div className="stat-bar" style={{ backgroundColor: barColors[index] }}></div>
            </div>
          ))}
        </div>
      ) : (
        <div className="graph-container">
          <h3 className="graph-title">Performance Metrics</h3>
          <div className="graph-wrapper">
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={data} margin={{ top: 20, right: 20, bottom: 20, left: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#374151" vertical={false} />
                <XAxis 
                  dataKey="name" 
                  axisLine={false}
                  tickLine={false}
                  tick={{ fill: '#9CA3AF' }}
                />
                <YAxis 
                  axisLine={false}
                  tickLine={false}
                  tick={{ fill: '#9CA3AF' }}
                />
                <Tooltip
                  contentStyle={{
                    backgroundColor: '#1F2937',
                    border: '1px solid #374151',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                  }}
                  itemStyle={{ color: '#00f3ff;' }}
                  labelStyle={{ 
                    color: '#00f3ff;',
                    fontWeight: 'bold',
                    marginBottom: '8px'
                  }}
                  formatter={(value, name) => [
                    name === 'Win %' ? `${value}%` : value.toLocaleString(),
                    name
                  ]}
                />
                <Bar dataKey="value" radius={[6, 6, 0, 0]}>
                  {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={barColors[index]} />
                  ))}
                  <LabelList 
                    dataKey="value" 
                    position="top" 
                    formatter={(value) => (value > 0 ? value : '')}
                    fill="#E5E7EB"
                    style={{ fontSize: '12px' }}
                  />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      )}
    </div>
  );
};

export default BattleStatsToggle;